export class InvoiceSearchParams {
  jobId: number = 0;
  consultantId: number = 0;
  statusId: number = 0;
  needsAttention: boolean = false;
}

